import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mc-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
